/*

 */

import React from 'react';

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import VisualizeContainerLoadingIndicator from "../../../clientShared/components/utility/progress/VisualizeContainerLoadingIndicator";
import ErrorInfoDisplay from "../../utilities/displayAreas/ErrorInfoDisplay";

function AdminDisplayUserAccountSettings({loading, error, userAccountSettings, ...props}) {

    if(error === true){
        return (
            <ErrorInfoDisplay showError={true}>
                Failed to load user account settings
            </ErrorInfoDisplay>
        );
    }

    if(loading === true || error === true || userAccountSettings === undefined){
        return <VisualizeContainerLoadingIndicator loadingResource={userAccountSettings} displayName={'User Account Settings'} {...props} />;
    }

    return (
        <React.Fragment>
            {
                Object.keys(userAccountSettings).map(
                    accountKey => {
                        return (
                            <React.Fragment key={accountKey}>
                                <b>{accountKey}</b>: {userAccountSettings[accountKey].toString()}<br/>
                            </React.Fragment>);
                    }
                )
            }
        </React.Fragment>
    );

}

const mapStateToProps = (state) => ({
});

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators({
    }, dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(AdminDisplayUserAccountSettings);